import Vue from 'vue'
import moment from 'moment-timezone'
import { formatDate } from '@smarttransit/common'

export default {
  name: 'st-calendar',
  props: {
    editable: Boolean,
    textFieldProps: Object,
    datePickerProps: Object,
    disabled: Boolean,
    minDate: Date,
    maxDate: Date,
    dateRange: Boolean,
    timezone: String,
    closeOnContentClick: Boolean,
    value: [Date, String, Number, Object] // if dateRange===true, then value becomes {fromDate: Date, toDate: Date}
  },
  data () {
    return {
      calendarDate: null,
      dateMenu: false,
      fromDateMenu: false,
      toDateMenu: false,
      isEditable: true,
      parsedCloseOnContentClick: true
    }
  },
  mounted () {
    if (this.$props.value) {
      this.setValueToCalendarDate(this.$props.value)
    }

    if (typeof this.$props.closeOnContentClick === 'boolean') {
      this.parsedCloseOnContentClick = this.$props.closeOnContentClick
    }

    this.isEditable = !this.$props.editable
  },
  computed: {
    computedDateFormatted () {
      return this.calendarDate ? formatDate(moment.utc(this.calendarDate).tz(this.$props.timezone)) : ''
    },
    computedDateFromFormatted () {
      return this.calendarDate && this.calendarDate.fromDate ? formatDate(moment.utc(this.calendarDate.fromDate).tz(this.$props.timezone)) : ''
    },
    computedDateToFormatted () {
      return this.calendarDate && this.calendarDate.toDate ? formatDate(moment.utc(this.calendarDate.toDate).tz(this.$props.timezone)) : ''
    },
    computedDateMin () {
      if (this.$props.minDate) {
        return moment(moment.utc(this.$props.minDate).tz(this.$props.timezone)).format('Y-MM-DD')
      }
    },
    computedDateMax () {
      if (this.$props.maxDate) {
        return moment(moment.utc(this.$props.maxDate).tz(this.$props.timezone)).format('Y-MM-DD')
      }
    }
  },
  watch: {
    calendarDate: function (newVal) {
      if (this.$props.dateRange) {
        this.$emit('input', {
          fromDate: newVal.fromDate ? this.fromUtcToTimezone(newVal.fromDate) : null,
          toDate: newVal.toDate ? this.fromUtcToTimezone(newVal.toDate) : null
        })
      } else {
        this.$emit('input', this.fromUtcToTimezone(newVal))
      }
    },
    value (val) {
      this.setValueToCalendarDate(val)
    },
    closeOnContentClick (val) {
      this.parsedCloseOnContentClick = val
    },
    disabled (val) {
      this.isEditable = !val
    }
  },
  methods: {
    setValueToCalendarDate (val) {
      if (this.$props.dateRange) {
        if (!this.calendarDate) {
          this.calendarDate = {}
        }

        this.calendarDate.fromDate = val && val.fromDate ? val.fromDate.toISOString() : null
        this.calendarDate.toDate = val && val.toDate ? val.toDate.toISOString() : null
      } else {
        this.calendarDate = val ? val.toISOString() : null
      }
    },
    fromUtcToTimezone (val) {
      return this.$props.timezone ? moment.tz(val, 'UTC').tz(this.$props.timezone).toDate() : new Date(val)
    }
  }
}
